import React from "react";
import moment from "moment";
import "moment/locale/es";
import { useHistory } from "react-router";
import { withTranslation } from "react-i18next";
import {
  ContractRequestService,
  LocalStorageService,
  QuestionnaireA3CloudService,
  ContractorService,
  CompanyService
} from "../../../services";
import { RequestForContractPanelView } from "../../views";
// import { profileIconDefault } from "../../../assets/logos/icons";

class RequestForContractAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractors: [],
      loading: true,
      companies: []
    };
  }

  url = process.env.REACT_APP_MIFIRMA_API;
  contractRequest = new ContractRequestService(this.url);
  contractorService = new ContractorService(this.url);
  localStrg = new LocalStorageService();
  questionnaire = new QuestionnaireA3CloudService(this.url);
  companyService = new CompanyService(this.url);
  token = {};

  toggleDialogYesNo = (dataItem, value) => {
    this.setState({
      dataItemUser: dataItem,
      showDialogYesNo: value,
    });
  };

  async componentDidMount() {
    this.token = this.localStrg.getLocalStorageItem("token").idToken;
    let user = this.localStrg.getLocalStorageItem("user");
    let clientID = user.userMetaData.userMifirma.clientId;
    let email = user.userMetaData.userMifirma.email;

    moment.locale("es");
    try {
      let location = this.props.location
      let idQuestionnaire = (location && location.state && location.state.questionnaireId) ? location.state.questionnaireId : null
      let questionnaire = await this.questionnaire.getQuestionnaireById(
        idQuestionnaire,
        this.token
      );
      let classifierKey = 'contractorKey'
      let contractorsData = await this.contractorService.getContarctorsOrSupliersByClientIdAndKey(clientID, classifierKey, this.token);
      let contractors = contractorsData.data.data;
      contractors.map((item) => {
        if (item.name === null) {
          item.name = "";
        }
        item.notifyBtn = true
        item.isChecked = false;
        return item;
      });
      let contractorsType = await this.contractorService.getPersonTypeByAdditionalKeyGroup('contractor', this.token)
      this.getCompanies()

      this.setState({
        loading: false,
        contractors: contractors,
        email: email,
        questionnaire: questionnaire,
        contractorsType: contractorsType.data
      });
    } catch (e) {
      this.props.changeRoute('home');
    }
  }

  getCompanies = async () => {
    try {
      let companies = await this.companyService.getCompanys(this.token)
      if (companies && companies.data.data && Number(companies.data.statusCode) === 200) {
        let allCompanies = []
        let companiesToClassified = []
        companies.data.data.map((company) => {
          let info = {}
          info.id = company.company.id
          info.name = company.company.companyName

          if (company.company.status) {
            allCompanies.push(info)
            companiesToClassified.push(info)
          }
          return company
        })
        this.setState({
          companies: allCompanies,
        })
      } else {
        this.props.history.push("/");
      }
    } catch (error) {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <RequestForContractPanelView
        {...this.state}
        toggleDialogYesNo={this.toggleDialogYesNo}
        contractRequest={this.contractRequest}
        token={this.token}
        changeRoute={this.props.changeRoute}
      />
    );
  }
}

export default withTranslation()(RequestForContractAction);
